const appTailorsI18nEn = {
  'Spezialisiert in Lederreparaturen': 'Specialized in leather repairs ',
  'Näht seit über 65 Jahren': 'Has been sewing for over 65 years',
  'Design und Handwerk sind Ihre Leidenschaft!': 'Design and craft are her passion!',
};

export default appTailorsI18nEn;
